<template>
<div class="work" id="work-8">
	<h2><span>03</span> GDY</h2>
	<div class="subtitle">
		<h3><span>Year</span>2023</h3>
		<h3><span>Product</span>Website</h3>
		<h3><span>Technology</span>Nuxt / Vue / Gsap</h3>
	</div>
	<blockquote>
		GDY it's a technology company with more than 30 years of experience in the development of ERP, CRM, WMS and custom projects for the B2B market.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>Update the website design to reflect the business innovation spirit and present the newest portfolio of products and services.</p>
			<h3>My Role</h3>
			<p>Design and develop the website UX and tecnhology, making use of Figma for designs and Nuxt for development, also creating the page animation and transitions.</p>
		</figcaption>
		<span><img src="../../assets/GDY-site-01.jpg" alt="GDY site"></span>
		<span><img src="../../assets/GDY-site-00.jpg" alt="GDY site"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>To showcase the innovation behind the GDY business, we proceed using a framework (Nuxt) that allows for significant creative freedom.</p>
			<p>Focusing on the user's interaction with smooth transitions and navigation, the core aspect was to provide playable content that is easy to digest.</p>
		</figcaption>
		<img src="../../assets/GDY-mb-1.jpg" alt="GDY mbile site">
		<img src="../../assets/GDY-Cases.jpg" alt="GDY mobile site">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>Clients and new leads get always amazed with the visuals and content, with this feedbak it motivates me to push my design and development capabilities.</blockquote> 
		</figcaption>
		
	</figure>
	<figure>
		<span><img src="../../assets/GDY-site-03.jpg" alt="GDY"></span>
	</figure>
	<blockquote>
		"I've great partnership with GDY, being involved in many of their products providing the UX design service, check the website here <a href="//gdy.com.br" target="_blank">GDY website</a>"
	</blockquote>
</div>
</template>